export const UPDATE_NOTIFICATION_ALERTS = 'UPDATE_NOTIFICATION_ALERTS';
export const RESET_NOTIFICATION_ALERTS = 'RESET_NOTIFICATION_ALERTS';